import log from '$$log';
import workloadCore from '../../workload/core';
import workloadRendererGrid from '../../workload/core/render/grid';

export default instance => {
  instance.attachEvent('onClickGridExpandButton', () => {
    const t = log.time('ganttRender.instance');
    instance.render();
    t.end();
    workloadRendererGrid.toggleGrid();
    workloadCore.calculateAndRender();
  });
};
